<template>
  <main v-if="page" class="layout-default">
    <Modules :modules="page.modules" />
  </main>
</template>

<script setup lang="ts">
import gsap from 'gsap';
import { useSeo } from '~/utils/useSeo';
import { useSiteHeaderBackground } from '~/utils/useSiteHeaderBackground';

const route = useRoute();
const slug = String(route.params.slug);

const i18n = useI18n();

const { data, error } = await useAsyncGql({
  operation: 'GetPageByTranslatedSlug',
  variables: { slug, locale: i18n.localeProperties.value.siteLocale },
});

const page = data.value?.page;

if (!page || error.value) {
  showError({
    statusCode: 404,
  });
}

if (page) {
  useSeo(page._seoMetaTags ?? [], page);
}

useSiteHeaderBackground('opaque');

definePageMeta({
  pageTransition: {
    onEnter(el, done) {
      const contentTextModules = Array.from(
        el.querySelectorAll('.content-text'),
      ).splice(0, 2);

      const tl = gsap.timeline({
        onComplete: done,
        defaults: {
          duration: 0.75,
        },
      });

      tl.fromTo(
        el,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          delay: 0.75,
        },
      ).fromTo(
        contentTextModules,
        {
          y: 50,
        },
        {
          y: 0,
        },
        '<',
      );
    },
    onLeave(el, done) {
      const tl = gsap.timeline({
        onComplete: () => {
          // NOTE: hack to prevent flashing of images after transition -> could surely been done another way
          setTimeout(() => done(), 1);
        },
      });

      tl.fromTo(
        el,
        {
          opacity: 1,
        },
        {
          opacity: 0,
        },
      );
    },
  },
});
</script>

<style scoped lang="scss">
.layout-default {
  display: flex;
  flex-direction: column;
  gap: var(--base-component-padding-block);
  padding-top: var(--site-padding-top);
}
</style>
